import Vue from 'vue';
import IsoBookingForm from './form/IsoBookingForm.vue';
import { setupCalendar } from 'v-calendar';

const isoBookingModules = document.querySelectorAll('[data-iso-booking-module]');

Vue.use(setupCalendar, {})

Vue.component('iso-booking-form', IsoBookingForm);

if (isoBookingModules.length > 0) {
    isoBookingModules.forEach((element) => {
		new Vue({
            el: element,
            components: {
                IsoBookingForm
            }
		});
	});
}